import type { GetServerSidePropsContext } from 'next'
import type { NextRouter } from 'next/router'
import { IncomingMessage } from 'http'
import { trackPageView, persistAdId } from '@mc/next-common'
import { forceExperiments } from '@mc/next-growthbook'
import { reportError } from '@mc/next-newrelic'

export async function requestSideEffects(
  req: GetServerSidePropsContext['req'] | IncomingMessage,
  res: GetServerSidePropsContext['res'],
  router: NextRouter,
) {
  try {
    trackPageView({ req, res, router })
    persistAdId({ req, res, router })
    forceExperiments({ req, res, router })
  } catch (e) {
    reportError(e as Error, {
      location: 'libs/request-side-effects.ts',
      message: 'Error occurred in request-side-effects',
    })
  }
}
